import { Injectable } from '@angular/core';
import { VARIABLE_CONSTANTS } from '@wms/variables';
import { WmHttpService,ProjectService, I18nService } from "@wms/services";
import { get } from 'lodash-es';
import { environment } from "@wms/app";
const listeners: any = {};

@Injectable({
  providedIn: 'root'
})
export class OauthService {
  TARGET = 'oauthConfiguration';
  locale: any;
  API_META: any = {
    getConfiguredProviders: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/oauth2/providers",
      method: "GET"
    },
    getDefaultProviders: {
      url: environment.SERVICES_BASE_PATH + "services/oauth2/providers/default",
      method: "GET"
    },
    addProvider: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/oauth2/providers",
      method: "POST"
    },
    getStudioAuthorizationUrl: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/oauth2/:providerId/authorizationUrl",
      method: "GET"
    }

  };

  constructor(private wmHttpService: WmHttpService,private projectService: ProjectService,private i18nService: I18nService) {
    this.wmHttpService.registerApiMeta(this.TARGET, this.API_META);
    this.locale = this.i18nService.getMessages();
  }

  onAuthWindowOpen(provider: string, providerInfo: any, res: any) {
    listeners[provider] = this.checkAuthenticationStatus.bind(this, provider, undefined, providerInfo, res);
    window.addEventListener("message", listeners[provider], false);
  }

  checkForWindowExistence(oAuthWindow: any, provider: string) {
    if (oAuthWindow && listeners[provider]) {
      if (!oAuthWindow.closed) { //.closed is supported across major browser vendors however for IE the user has to enable protected mode from security options
        setTimeout(this.checkForWindowExistence.bind(this, oAuthWindow, provider), 3000);
      } else {
          window.removeEventListener("message", listeners[provider]);
          delete listeners[provider];
      }
    }
  }

  checkAuthenticationStatus(providerId: string, evt: any, providerInfo: any, res: any) {
    var accessTokenKey = providerId + '.access_token',
      accessTokenOrCode = localStorage.getItem(accessTokenKey);
    if (evt && evt.origin !== window.location.origin) {
      return;
    }
    if (accessTokenOrCode) {
      if (this.getFlow(providerInfo) === 'pkce') {
        // var req = 'client_id=' + providerInfo.clientId + '&code=' + accessTokenOrCode + '&grant_type=authorization_code&code_verifier=' + code_verifier + '&redirect_uri=' + redirectUri;
        // var params = {
        //     "method": 'POST',
        //     "target": 'WebService',
        //     "dataParams": req,
        //     "url": providerInfo.accessTokenUrl,
        //     "headers": {"Content-type": "application/x-www-form-urlencoded"},
        //     "withCredentials": false,
        //     "isDirectCall": true,
        //     "isExtURL": true
        // };
        // WebService.invokeJavaService(params, function (response, xhrObj) {
        //     triggerAccessTokenSuccessCallback(providerId, successCallback, accessTokenKey, response.access_token);
        // });
    } else {
      this.triggerAccessTokenSuccessCallback(providerId, accessTokenKey, accessTokenOrCode, res);
    }
    }
  }

  getAccessTokenPlaceholder(provider: string) {
    const projDetails = this.projectService.getDetails();
    return 'WM_STUDIO_' + projDetails.name + "_" + provider + VARIABLE_CONSTANTS.REST_SERVICE.ACCESSTOKEN_PLACEHOLDER.RIGHT;
  }

  triggerAccessTokenSuccessCallback(providerId: any, accessTokenKey: any, token: any, res: any) {
    localStorage.removeItem(accessTokenKey);
    sessionStorage.setItem(this.getAccessTokenPlaceholder(providerId), token);
    window.removeEventListener("message", listeners[providerId]);
    setTimeout(() => {
      delete listeners[providerId];
      res(token);
    });
  }

  getAuthorizationUrl(params: any) {
    return this.wmHttpService.execute({
      target: "oauthConfiguration",
      action: "getStudioAuthorizationUrl",
      pathParams: {
        projectId: this.projectService.getProjectId(),
        providerId: params.providerId,
      },
      spinnerInfo: {
        showSpinner:  params.showSpinner,
        spinnerMsg: this.locale.LABEL_PREPARING_APIS
      }
    });
  }

  loadConfiguredProviders(params?: any) {
    return this.wmHttpService.execute({
      target: "oauthConfiguration",
      action: "getConfiguredProviders",
      pathParams: {
        projectID: this.projectService.getProjectId()
      },
      toasterInfo: {
        'error'  : { title:  this.locale.MESSAGE_ERROR_TITLE }
      },
      spinnerInfo: {
        showSpinner:  params?.showSpinner,
        spinnerMsg: this.locale.LABEL_PREPARING_APIS
      }
    });
  }

  addProvider(connectionParams: any){
    return this.wmHttpService.execute({
      target: "oauthConfiguration",
      action: "addProvider",
      data: connectionParams.providers,
      pathParams:{
        projectId: this.projectService.getProjectId()
      },
      toasterInfo: {
        'success': { title: this.locale.MESSAGE_SUCCESS_TITLE, description: 'Saved Successfully!' },
        'error'  : { title:  this.locale.MESSAGE_ERROR_TITLE}
      }
    });
  }

  /**
   * this functions returns which oAuth flow to be triggered
   * @param providerInfo
   */
  getFlow(providerInfo: any) {
    let oAuthFlow = get(providerInfo, 'oauth2Flow');
    oAuthFlow = oAuthFlow && oAuthFlow.toLowerCase();
    if (get(providerInfo, 'oAuth2Pkce.enabled') === true) {
        oAuthFlow = 'pkce';
    }
    return oAuthFlow;
  }

  /**
     * function to construct the url for implicit or pkce flow.
     * @param providerId provider id for which the url has to be set
     * @param providerInfo provider object which contains details such as scope, client id etc
     * @param requestSourceType requesting source is web or mobile or wavelens
     * @returns url string
     */
  constructURLForImplicitOrPKCE(providerId: string, providerInfo: any, requestSourceType: any, code_challenge: any, flow: any) {
    let implicitUri;
    const redirectUri = 'http://' + window.location.host + '/studio/oAuthCallback.html';
    let state = {providerId: providerId, suffix: VARIABLE_CONSTANTS.REST_SERVICE.ACCESSTOKEN_PLACEHOLDER.RIGHT, requestSourceType: requestSourceType, flow: flow.toLowerCase()};
    let scopes = providerInfo.scopes.map((scope: any)  => scope.name ).join(' ');
    let authUrlArr = providerInfo.authorizationUrl.split('?'), connector;
    if (authUrlArr.length === 1) {
        //query params don't exist
        connector = '?';
    } else if (authUrlArr.length > 1 && authUrlArr[1] !== '') {
        //query params exist. Append & instead of ?.
        connector = '&';
    } else {
        //nothing exists after '?'. client_id can be directly appended;
        connector = '';
    }
    const commonUrl = providerInfo.authorizationUrl + connector + 'client_id=' + providerInfo.clientId + '&redirect_uri=' + redirectUri + '&state=' + encodeURIComponent(JSON.stringify(state)) + '&scope=' + encodeURIComponent(scopes);
    if (flow === 'implicit') {
        var responseType = providerInfo.responseType ? providerInfo.responseType : 'token';
        implicitUri = commonUrl + '&response_type=' + responseType;
    } else {
        implicitUri = commonUrl + '&response_type=code&code_challenge=' + code_challenge + '&code_challenge_method=' + get(providerInfo, 'oAuth2Pkce.challengeMethod');
    }
    return implicitUri;
  }

  startoAuthFlow(url: string, providerId: string, providerInfo: any, res: any) {
    // TO DO
    // if (Utils.isIE()) { //handling for IE
    //     handleLoginForIE(url, providerId, onSuccess, onError);
    // } else {
    //}
    this.postGetAuthorizationURL(url, providerId, providerInfo, res);
  }

  /**
     * this function is a callback function which enables the listener and checks for the window existence
     * @param providerId
     * @param onSuccess
     * @param url
     */
  postGetAuthorizationURL(url: string, providerId: any, providerInfo: any, res: any) {
    const newWindowProps = "width=400,height=600";
    const oAuthWindow = window.open(url, '_blank', newWindowProps);
    this.onAuthWindowOpen(providerId, providerInfo, res);
    this.checkForWindowExistence(oAuthWindow, providerId);
  }

  /* this function is used to perform the authorization by opening the window and having active listeners */
  performAuthorization(url: string, providerId: string, providerInfo: any) {
    return new Promise((res, rej) => {
      let requestSourceType = 'WEB', flow = this.getFlow(providerInfo);
      if (url) {
          if (flow === 'implicit') {
              url = this.constructURLForImplicitOrPKCE(providerId, providerInfo, requestSourceType, undefined, flow);
              this.startoAuthFlow(url, providerId, providerInfo, res);
          } else if (flow === 'pkce') {
              // code_verifier = generateRandomString();
              // var code_challenge;
              // if (_.get(providerInfo, 'oAuth2Pkce.challengeMethod') === 'plain') {
              //     code_challenge = code_verifier;
              //     url = constructURLForImplicitOrPKCE(providerId, providerInfo, requestSourceType, code_challenge, flow);
              //     startoAuthFlow(url, providerId, onSuccess, onError, providerInfo);
              // } else {
              //     sha256(code_verifier).then(function(v) {
              //         code_challenge = base64urlencode(v);
              //         url = constructURLForImplicitOrPKCE(providerId, providerInfo, requestSourceType, code_challenge, flow);
              //         startoAuthFlow(url, providerId, onSuccess, onError, providerInfo);
              //     });
              // }
          } else {
              this.startoAuthFlow(url, providerId, providerInfo, res);
          }
      } else {
          // if (CONSTANTS.isWaveLens) {
          //     requestSourceType = 'WAVELENS';
          // } else if (CONSTANTS.hasCordova) {
          //     requestSourceType = 'MOBILE';
          // }
          // return getAuthorizationUrl({
          //     'providerId': providerId,
          //     'requestSourceType' : requestSourceType
          // }).then(function(response) {
          //     if (!$rs.isStudioMode) {
          //         $rs.providersConfig[providerId] = {
          //             name: providerId,
          //             url: response,
          //             invoke: function () {
          //                 if (Utils.isIE()) { //handling for IE
          //                     handleLoginForIE(response, providerId, onSuccess, onError);
          //                 } else {
          //                     postGetAuthorizationURL(response, providerId, onSuccess, providerInfo);
          //                 }
          //             }
          //         };
          //     }
          // });
      }
    });

  }
}
